import { DataEntryMode } from '../../../types/DataEntryMode';
import { PanelType } from '../../../types/PanelType';
import { BoardMembersValidationEditSchema } from '../../../types/Validation/BoardMembersValidationEditSchema';
import { BoardMembersValidationSchema } from '../../../types/Validation/BoardMembersValidationSchema';
import FormTextbox from '../../FormInputs/FormTextbox/FormTextbox';
import Panel from '../../Panel/Panel';
import { BoardMembersFormViewModel } from 'src/types/BoardMembersFormViewModel';
import FormDropdown from '../../../components/FormInputs/FormDropdown/FormDropdown';
import FormDateSelector from '../../../components/FormInputs/FormDateSelector/FormDateSelector';
import { selectSelectedDistrict } from '../../../redux/slices/appSlice';
import { useAppSelector } from '../../../redux/hooks';
import { useFormikContext } from 'formik';
import { BoardMembersItemModel } from 'src/types/BoardMembersItemModel';
import { useEffect } from 'react';
import { MAX_DATE } from 'src/types/Constants';

interface BoardMembersInformationProps {
  dataEntryMode: DataEntryMode;
  formViewModel: BoardMembersFormViewModel;
  allowEdit?: boolean;
}

const BoardMembersPrimaryInformationPanel: React.FC<
  BoardMembersInformationProps
> = ({ dataEntryMode, formViewModel, allowEdit }) => {

  const { setFieldValue } =
    useFormikContext<BoardMembersItemModel>();

  const selectedDistrict: { districtId: string } = useAppSelector(selectSelectedDistrict);

  useEffect(() => {
      setFieldValue('leaIdentifier', selectedDistrict.districtId, false);
  }, [selectedDistrict.districtId, setFieldValue]);

  return (
    <Panel panelType={PanelType.INFO} heading="Board Member Information">
      <div className="field-row">
        <FormTextbox
          displayName="LEA"
          field="leaIdentifier"
          validationSchema={BoardMembersValidationSchema}
          disabled={true}
        />
        <FormDropdown
          displayName="Membership Type"
          field="membershipType"
          options={formViewModel.membershipType}
          validationSchema={BoardMembersValidationSchema}
          disabled={!allowEdit}
        />
        <FormDropdown
          displayName="Position Type"
          field="positionType"
          options={formViewModel.positionType}
          validationSchema={BoardMembersValidationSchema}
          disabled={!allowEdit}
        />
      </div>

      <div className="field-row">
        <FormTextbox
          displayName="First Name"
          field="firstName"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
        <FormTextbox
          displayName="Last Name"
          field="lastOrSurname"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
        <FormTextbox
          displayName="Email Address"
          field="email"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
        />
      </div>

      <div className="field-row field-row--align-start">
        <FormDateSelector
          displayName="Term Start Date"
          field="termStartDate"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
          maxDate={MAX_DATE}
          isClearable
        />
        <FormDateSelector
          displayName="Term End Date"
          field="termEndDate"
          validationSchema={
            dataEntryMode === 'new'
              ? BoardMembersValidationSchema
              : BoardMembersValidationEditSchema
          }
          disabled={!allowEdit}
          maxDate={MAX_DATE}
          isClearable
        />
      </div>
    </Panel>
  );
};

export default BoardMembersPrimaryInformationPanel;
